import { format, getSoilUnitOptions, groupBy, isArrayEmpty, isTerraMapLayer, soilColors, SoilMapView, SoilUnit, sortDates } from "../../../omnia"
import { IDataLayer, IDataLayerType, ILayerViewModel, LayerTypeId } from "../../../types"
import { groupMapFeaturesInSingleLayer } from "../context"
import { createMapViewGroup } from "../group"
import { IViewerContext } from "../types"

export function createTerraMapGroup(ctxt: IViewerContext) {

    const { soilSvc, layers } = ctxt

    const layerTypes = soilSvc.getLayerTypes().filter(isTerraMapLayer)

    const viewers = layerTypes.map(t => {

        const typeLayers = retainLatestLayers(
            layers
                .filter(l => l.TypeId === t.TypeId)
                .filter(l => !Boolean(l.ParentId))
        )

        return isArrayEmpty(typeLayers)
            ? null
            : new TerraMapView(ctxt, typeLayers, t, LayerTypeId[t.TypeId])

    }).filter(v => !!v)

    return createMapViewGroup("S", "TerraMap", viewers)

}

export class TerraMapView extends SoilMapView {

    constructor(private ctxt: IViewerContext, layers: IDataLayer[], type: IDataLayerType, element: string) {

        super(format.formatChemicalCompoundNameAsUnicode(type.Name), element)

        this._layers = createLayers(ctxt, layers)

        this._colors = (type.Ranges || []).map(r => ({
            Value: r.Min,
            Colour: r.FillColor,
            Index: hasIndexUnits(type.TypeId) ? soilColors.getValueIndex(r.Min, element) : null
        }))



        if (hasIndexUnits(type.TypeId)) {
            super.setupUnits(
                getSoilUnitOptions(),
                () => ctxt.soilSvc.units.soil
            )
        }

    }

    protected showLayer(l: ILayerViewModel, visibilityFilter?: (l: ILayerViewModel) => boolean) {
        super.showLayer(l, visibilityFilter)
    }

    protected setCurrentUnit(unit: SoilUnit) {
        super.setCurrentUnit(unit)
        this.ctxt.soilSvc.units.soil = unit
    }

}

function createLayers(ctxt: IViewerContext, layers: IDataLayer[]) {

    const { soilSvc, createLayerViewModel } = ctxt

    return layers.map(l => {
        const field = soilSvc.findField(l.FieldId)
        return createLayerViewModel(l, field, { addToMap: !groupMapFeaturesInSingleLayer })
    })
}

function hasIndexUnits(type: LayerTypeId) {

    switch (type) {

        case LayerTypeId.P2O5:
        case LayerTypeId.K2O:
        case LayerTypeId.MgO:
            return true

        default:
            return false

    }
}

function retainLatestLayers(layers: IDataLayer[]): IDataLayer[] {

    const groups = groupBy(layers, l => l.FieldId)

    const latest = groups.map(g => {

        const sorted = g.values.sort((a, b) => {
            let s = ((b.FirstYearId ?? 0) - (a.FirstYearId ?? 0))
            s ||= sortDates(b.Date, a.Date)
            s ||= b.DataLayerId - a.DataLayerId
            return s

        })

        return sorted[0]

    })

    return latest

}

